import { CreatedClassList } from "./CreatedClassList";
import { CreatedClassShow } from "./CreatedClassShow";

export default {
  list: CreatedClassList,
  show: CreatedClassShow,
};

